import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

import config from 'configs/app';
import PageTitle from 'ui/shared/Page/PageTitle';

const UserOps = dynamic(() => import('ui/pages/UserOps'), { ssr: false });

const Page: NextPage = () => {
  const title = config.meta.seo.enhancedDataEnabled ?
    `${ config.chain.name } user operations` :
    'User operations';

  return (
    <PageNextJs pathname="/ops">
      <PageTitle title={ title } withTextAd/>
      <UserOps hideTitle/>
    </PageNextJs>
  );
};

export default Page;

export { userOps as getServerSideProps } from 'nextjs/getServerSideProps';
